import { Stack, TextField, Link as A, MenuItem } from "@mui/material"
import Checkbox from "../../Inputs/Checkbox";
import origins from '../../../config/origins.json'
import { txt } from "../../../services/translation";

export default function Terms({user, onChange, errors, show}){

    return show && <>
        <TextField
            label={txt('howDidYouHearAboutUs')}
            select
            value={user.origin?.id || ''}
            onChange={e => onChange({...user, origin: 
                origins.find(o => o.id === e.target.value)
            })}
            required
            size='small'
        >
            {origins.map(o => 
                <MenuItem value={o.id} key={o.id}>{txt(o.id + 'Origin') || o.title}</MenuItem>    
            )}
        </TextField>

        {user.origin?.id === 'autre' &&
            <TextField
                label={txt('specify')}
                value={user.comment || ''}
                onChange={e => onChange({...user, comment: e.target.value})}
                required
                size='small'
                inputProps={{maxLength: 100}}
            />
        }
        
        <Stack direction='column'>
            <Checkbox 
                label={<>{txt('acceptTerms')} <A href="https://www.learnylib.com/cgv/">{txt('termsAndConditions')}</A></>}
                value={user.terms}
                onChange={e => onChange({...user, terms: e.target.checked})}
                error={errors.terms ? true : false}
                helperText={errors.terms || ''}
                required
            />

            {/*<Checkbox 
                label={<>{txt('newsletterOptIn')}</>}
                value={user.newsletter}
                onChange={e => onChange({...user, newsletter: e.target.checked})}
            />*/}

            <Checkbox 
                label={txt('handicap')}
                value={user.handicap}
                onChange={e => onChange({...user, handicap: e.target.checked})}
            />
        </Stack>
    </>

}